import axios from "axios";
import { Message } from "element-ui";

// create an axios instance
const service = axios.create({
  // baseURL: process.env.NODE_ENV === "development" ? "/" : "/", // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
  headers: {
    common: {
      "X-Requested-With": "XMLHttpRequest",
    },
  },
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const urlWhiteList = ["/booklib/v2/chat/init"];
    const res = response.data || {};
    const { url } = response.config;
    if (
      url.includes("/booklib/v2/") &&
      !urlWhiteList.includes(url) &&
      res.status !== 200
    ) {
      const errorCodeHashMap = new Map().set(401, () => {
        Message.error("抱歉，您的登录已过期，请重新登录以继续使用服务。");
        const { hash, origin, pathname } = location;
        sessionStorage.setItem("openSignInDialog", hash);
        setTimeout(() => {
          location.href = `${origin}${pathname}`;
        }, 1000);
      });

      if (errorCodeHashMap.has(res.status)) {
        errorCodeHashMap.get(res.status)();
      }
      throw res;
    }
    return res;
  },
  (error) => {
    console.log("err" + error); // for debug
    const { message } = error;
    if (message.includes("timeout")) {
      Message.error("请求超时了，请您刷新页面重试！");
      return Promise.reject(error);
    }
    Message.error("服务异常，请您联系客服！");
    return Promise.reject(error);
  }
);

export default service;
